import {post} from "@/axios/request";

export const getDeptList = (page, size, data) => {
  return post("/service/api/client/getDeptList", {
    page,
    size,
    ...data
  })
}

export const getPrefectureList =  (page, size, data) => {
  return post("/service/api/client/getCatalogList", {
    page,
    size,
    ...data
  })
}
